/* tm-wishlist : favoris (coeurs) stockés dans le navigateur du client */
(function () {
  if (window.__tmWishlist) return;
  var KEY = 'tm_wishlist_v1';
  var cfgEl = function () { return document.querySelector('[data-tm-wishlist-config]'); };
  var cfg = function () {
    var el = cfgEl();
    var d = (el && el.dataset) || {};
    return {
      pageUrl: d.pageUrl || '/pages/favoris',
      linkLabel: d.linkLabel || 'Mes favoris',
      addLabel: d.addLabel || 'Ajouter aux favoris',
      removeLabel: d.removeLabel || 'Retirer des favoris',
      showCards: d.showCards !== 'false',
      showHeader: d.showHeader !== 'false',
      showCount: d.showCount !== 'false'
    };
  };

  var HEART = '<svg aria-hidden="true" focusable="false" class="tm-wl-icon" viewBox="0 0 24 24"><path d="M22 8.862a5.95 5.95 0 0 1-1.654 4.13c-2.441 2.531-4.809 5.17-7.34 7.608-.581.55-1.502.53-2.057-.045l-7.295-7.562c-2.205-2.286-2.205-5.976 0-8.261a5.58 5.58 0 0 1 8.08 0l.266.274.265-.274A5.612 5.612 0 0 1 16.305 3c1.52 0 2.973.624 4.04 1.732A5.95 5.95 0 0 1 22 8.862z" stroke-width="1.5" stroke-linejoin="round"/></svg>';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('tm-wishlist:change', { detail: list }));
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var list = read(), i = list.indexOf(h);
    if (i === -1) list.push(h); else list.splice(i, 1);
    write(list);
    return i === -1;
  }
  function remove(h) {
    write(read().filter(function (x) { return x !== h; }));
  }

  function handleOf(card) {
    var u = card.getAttribute('data-url') || '';
    var m = u.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* ---------- Coeurs sur les cartes produit ---------- */
  function decorateCards(root) {
    if (!cfg().showCards) return;
    (root || document).querySelectorAll('grid-item[data-url], .grid-item.product-item[data-url]').forEach(function (card) {
      if (card.querySelector(':scope .tm-wl-heart')) return;
      var h = handleOf(card);
      var host = card.querySelector('.product-item__image');
      if (!h || !host) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tm-wl-heart';
      b.setAttribute('data-tm-handle', h);
      b.innerHTML = HEART;
      host.appendChild(b);
      paint(b);
    });
  }
  function paint(b) {
    var on = has(b.getAttribute('data-tm-handle'));
    var c = cfg();
    b.classList.toggle('is-active', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', on ? c.removeLabel : c.addLabel);
  }
  function paintAll() {
    document.querySelectorAll('.tm-wl-heart').forEach(paint);
    updateCount();
  }

  /* ---------- Suivi (Google Analytics + Tag Manager) ---------- */
  function itemOf(b) {
    var card = b.closest('grid-item, .tm-wl-card');
    var t = card && card.querySelector('.product-item__title, .tm-wl-card__title');
    var p = card && card.querySelector('.new-price, .tm-wl-card__price span:last-child, .price');
    var price = p ? parseFloat(p.textContent.replace(/[^\d,.]/g, '').replace(',', '.')) : NaN;
    var it = { item_id: b.getAttribute('data-tm-handle'), item_name: t ? t.textContent.trim() : (b.getAttribute('data-tm-name') || b.getAttribute('data-tm-handle')) };
    if (isNaN(price) && b.hasAttribute('data-tm-price')) price = parseFloat(b.getAttribute('data-tm-price'));
    if (!isNaN(price)) it.price = price;
    return it;
  }
  function track(name, b) {
    try {
      var it = itemOf(b);
      var params = { currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', items: [it] };
      if (it.price) params.value = it.price;
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      (window.dataLayer = window.dataLayer || []).push({ event: 'tm_' + name, ecommerce: params });
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.tm-wl-heart');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggle(b.getAttribute('data-tm-handle'));
    track(on ? 'add_to_wishlist' : 'remove_from_wishlist', b);
    if (on) {
      b.classList.add('is-pop');
      setTimeout(function () { b.classList.remove('is-pop'); }, 300);
    }
  }, true);

  /* ---------- Coeur dans l'en-tête ---------- */
  function navHTML(c, cls) {
    return '<div class="' + cls + ' tm-wl-nav"><a href="' + c.pageUrl + '" class="navlink tm-wl-navlink" title="' + c.linkLabel + '">' +
      HEART + '<span class="tm-wl-count" hidden></span><span class="visually-hidden">' + c.linkLabel + '</span></a></div>';
  }
  function decorateHeader() {
    var c = cfg();
    if (!c.showHeader) return;
    [['.header__desktop__buttons', 'header__desktop__button'], ['.header__mobile__right', 'header__mobile__button']].forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (wrap) {
        if (wrap.querySelector('.tm-wl-nav')) return;
        var cart = wrap.querySelector('a[href$="/cart"]');
        var anchor = cart && cart.closest('.' + pair[1]);
        var tpl = document.createElement('div');
        tpl.innerHTML = navHTML(c, pair[1]);
        var node = tpl.firstChild;
        if (anchor && anchor.parentNode === wrap) wrap.insertBefore(node, anchor);
        else wrap.appendChild(node);
      });
    });
    updateCount();
  }
  function updateCount() {
    var n = read().length, c = cfg();
    document.querySelectorAll('.tm-wl-count').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = !(c.showCount && n > 0);
    });
  }

  /* ---------- Page « Mes favoris » ---------- */
  var fmt;
  function money(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      fmt = fmt || new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur });
      return fmt.format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function imgUrl(src, w) {
    if (!src) return '';
    try { var u = new URL(src, location.origin); u.searchParams.set('width', w); return u.toString(); }
    catch (e) { return src; }
  }
  function cardEl(p, labels) {
    var li = document.createElement('li');
    li.className = 'tm-wl-card';
    var a = document.createElement('a');
    a.className = 'tm-wl-card__link';
    a.href = p.url;
    var fig = document.createElement('div');
    fig.className = 'tm-wl-card__media';
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = imgUrl(p.featured_image, 640);
      img.srcset = imgUrl(p.featured_image, 360) + ' 360w, ' + imgUrl(p.featured_image, 640) + ' 640w, ' + imgUrl(p.featured_image, 960) + ' 960w';
      img.sizes = '(min-width: 990px) 25vw, 50vw';
      img.alt = p.title;
      img.loading = 'lazy';
      img.width = 640; img.height = 768;
      fig.appendChild(img);
    }
    var t = document.createElement('p');
    t.className = 'tm-wl-card__title';
    t.textContent = p.title;
    var pr = document.createElement('p');
    pr.className = 'tm-wl-card__price';
    if (!p.available) {
      pr.textContent = labels.soldOut;
    } else {
      if (p.compare_at_price && p.compare_at_price > p.price) {
        var old = document.createElement('s');
        old.textContent = money(p.compare_at_price);
        pr.appendChild(old);
        pr.appendChild(document.createTextNode(' '));
      }
      var cur = document.createElement('span');
      cur.textContent = money(p.price);
      pr.appendChild(cur);
    }
    a.appendChild(fig); a.appendChild(t); a.appendChild(pr);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tm-wl-heart is-active';
    b.setAttribute('data-tm-handle', p.handle);
    b.setAttribute('aria-pressed', 'true');
    b.setAttribute('aria-label', cfg().removeLabel);
    b.innerHTML = HEART;
    li.appendChild(a); li.appendChild(b);
    return li;
  }
  var pageCache = {};
  function renderPage() {
    var root = document.querySelector('[data-tm-wishlist-page]');
    if (!root) return;
    var grid = root.querySelector('[data-tm-wl-grid]');
    var empty = root.querySelector('[data-tm-wl-empty]');
    var loading = root.querySelector('[data-tm-wl-loading]');
    var labels = { soldOut: root.getAttribute('data-sold-out') || 'Épuisé' };
    var handles = read();
    if (!root.__tmViewed) {
      root.__tmViewed = true;
      try {
        if (typeof window.gtag === 'function') window.gtag('event', 'tm_view_wishlist', { item_count: handles.length });
        (window.dataLayer = window.dataLayer || []).push({ event: 'tm_view_wishlist', item_count: handles.length });
      } catch (e) {}
    }
    if (!handles.length) {
      grid.innerHTML = ''; loading.hidden = true; empty.hidden = false; return;
    }
    Promise.all(handles.map(function (h) {
      if (pageCache[h]) return Promise.resolve(pageCache[h]);
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) pageCache[h] = p; return p; })
        .catch(function () { return null; });
    })).then(function (products) {
      grid.innerHTML = '';
      var shown = 0;
      products.forEach(function (p) {
        if (!p) return;
        grid.appendChild(cardEl(p, labels));
        shown++;
      });
      loading.hidden = true;
      empty.hidden = shown > 0;
    });
  }
  /* sur la page, retirer un coeur fait disparaître la carte */
  document.addEventListener('tm-wishlist:change', function () {
    var root = document.querySelector('[data-tm-wishlist-page]');
    if (!root) return;
    var keep = read();
    root.querySelectorAll('.tm-wl-card').forEach(function (li) {
      var h = li.querySelector('.tm-wl-heart').getAttribute('data-tm-handle');
      if (keep.indexOf(h) === -1) li.remove();
    });
    if (!root.querySelector('.tm-wl-card')) root.querySelector('[data-tm-wl-empty]').hidden = false;
  });

  /* ---------- Démarrage ---------- */
  function init() {
    decorateHeader();
    decorateCards();
    paintAll();
    renderPage();
  }
  document.addEventListener('tm-wishlist:change', paintAll);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { paintAll(); renderPage(); } });

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; decorateCards(); decorateHeader(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.__tmWishlist = { read: read, has: has, toggle: toggle, remove: remove, paint: paintAll };
})();
